export default {
  productShow: {
    showInfo: '查看详情'
  },

  router: {
    index: {
      title: "上海杉脉电子科技 | 智能门禁系统 · 智能储物柜/展柜定制 · 电子安防解决方案",
      keywords: "杉脉, 上海杉脉, 杉脉科技, 上海杉脉科技发展有限公司,上海杉脉科技发展有限公司官网",
      description: "为客户提供产品技术支持、提供安防系统工程、综合布线、智能化系统集成工程、系统保养维护等项目的综合解决方案设计。"
    },
    entranceGuard: {
      title: "智能门禁 | 智能门禁系统 | 上海杉脉科技",
      keywords: "智能门禁系统,门禁管理系统,无线门禁,智能门锁,门禁一卡通,杉脉科技门禁",
      description: "杉脉科技智能门禁系统提供多样化的门禁解决方案，包括无线门禁、智能门锁、一卡通系统等。支持人脸识别、指纹识别、IC卡等多种开门方式，为企业提供安全可靠的门禁管理系统。"
    },
    displayCase: {
      title: "智能展柜系统 | 智能储物柜 | 上海杉脉科技",
      keywords: "智能展柜,智能储物柜,智能陈列柜,展示柜管理系统,智能展示系统,杉脉科技展柜",
      description: "杉脉科技智能展柜系统采用先进的智能锁具和管理软件，为珠宝、奢侈品等高价值商品提供安全可靠的展示解决方案。支持远程管理、智能防盗、数据统计等功能。"
    },
    softwarePlatform: {
      title: "智能管理软件平台 | 上海杉脉科技",
      keywords: "智能管理系统,门禁管理软件,展柜管理平台,物联网管理系统,杉脉科技软件",
      description: "杉脉科技智能管理平台提供门禁系统、展柜系统的统一管理界面，支持多设备联动、数据分析、远程控制等功能，助力企业实现智能化转型。"
    },
    entranceGuardSoftware: {
      title: "智能门禁管理软件 | 上海杉脉科技",
      keywords: "门禁管理软件,门禁控制系统,访客管理系统,考勤管理,门禁数据分析",
      description: "杉脉科技门禁管理软件提供完整的门禁控制功能，包括权限管理、访客管理、考勤统计、实时监控等，支持手机APP远程控制，让门禁管理更智能、更便捷。"
    },
    exhibitionSoftware: {
      title: "智能展柜平台 | 上海杉脉科技",
      keywords: "智能展柜软件,展柜管理系统,智能展示平台,展柜监控软件,杉脉科技展柜软件",
      description: "杉脉科技智能展柜平台采用先进的物联网技术，为珠宝、奢侈品等高价值商品提供安全可靠的展示解决方案。"
    },
    aftTheSoftware: {
      title: "智能售后平台 | 上海杉脉科技",
      keywords: "智能售后系统,售后管理软件,设备维护平台,远程服务系统,杉脉科技售后软件",
      description: "杉脉科技智能售后平台提供设备维护，实现售后服务的智能化管理，提高服务效率和客户满意度。"
    },
    contact: {
      title: "联系我们 | 上海杉脉科技",
      keywords: "杉脉科技联系方式,上海杉脉地址,杉脉科技电话,杉脉科技邮箱,智能门禁系统供应商",
      description: "上海杉脉科技发展有限公司专注于智能门禁、智能展柜、智能储物柜等智能化系统的研发与应用，提供完整的智能化解决方案。欢迎致电咨询。"
    },
    productShow: {
      title: "产品展示 | 上海杉脉科技",
      keywords: "智能门禁产品,智能展柜产品,智能储物柜产品,杉脉科技产品展示,门禁控制器,电子锁,人脸识别门禁",
      description: "上海杉脉科技产品展示页面，展示智能门禁系统、智能展柜、智能储物柜等产品，涵盖门禁控制器、电子锁、人脸识别门禁等多种智能化设备。"
    },
    productInfoShow: {
      title: "产品详情展示 | 上海杉脉科技",
      keywords: "智能门禁产品详情,智能展柜产品详情,智能储物柜产品参数,杉脉科技产品规格,门禁设备技术参数",
      description: "上海杉脉科技产品详情页面，提供智能门禁系统、智能展柜、智能储物柜等产品的详细技术参数、功能特点、应用场景等信息。"
    },
    accessControlIntelligentSystemServices: {
      title: "智能门禁管理系统 | 上海杉脉科技",
      keywords: "智能门禁管理系统,门禁控制系统,门禁管理软件,人脸识别门禁系统,门禁解决方案,杉脉科技门禁服务",
      description: "杉脉科技智能门禁管理系统涵盖独立式、云平台以及移动应用程序，支持人脸识别、指纹识别、IC卡等多种开门方式，在安全性、可管理性、灵活性等方面均表现出色，能为多数使用场景提供安全保障并带来管理上的便利。"
    },
    smartDisplayCaseService: {
      title: "智能展示柜 | 上海杉脉科技",
      keywords: "智能展示柜,智能展柜系统,展柜智能锁,珠宝展柜管理,奢侈品展柜解决方案,杉脉科技展柜服务",
      description: "杉脉科技智能展示柜旨在构建更安全、更便捷、更智能的防护体系，助力高端零售业务数字化转型。针对传统机械柜锁束缚大、信息孤岛管理等问题，进一步规范业务流程、简化操作步骤、提升运营效率，助力门店智能化建设，赋能企业管理。"
    },
    smartLockersService: {
      title: "智能储物柜 | 上海杉脉科技",
      keywords: "智能储物柜,智能存包柜,共享储物柜,储物柜管理系统,学校储物柜解决方案,杉脉科技储物柜服务",
      description: "杉脉科技智能储物系统支持多种开启方式，能够快速实现物品的存取，兼具高安全性与便捷性。能有效提升空间利用率，方便管理员轻松调配，灵活性出众，可设置临时或长期使用权限，为企业和员工带来诸多便利。"
    },
    glassDoorHandleSmartLockService: {
      title: "智能拉手锁 | 上海杉脉科技",
      keywords: "智能拉手锁,玻璃门智能锁,无线智能锁,暗装智能锁,商用智能锁,杉脉科技拉手锁服务",
      description: "杉脉科技智能拉手锁能够暗装于玻璃门把手内部，无需额外安装锁具，拥有读卡、NFC等多种识别方式，通过蓝牙无线传输与私有安全网关相连，为玻璃门提供安全便捷的智能锁解决方案。"
    },
    rfidTakeService: {
      title: "RFID智能盘点 | 上海杉脉科技",
      keywords: "RFID智能盘点,RFID资产管理,智能盘点系统,仓库盘点解决方案,固定资产盘点,杉脉科技RFID服务",
      description: "杉脉科技基于RFID技术的智能管理及防丢失解决方案，通过部署RFID标签、读写器、智能围栏、电子门禁等硬件设备与后台管理系统，实现快速盘点、实时监控、防盗报警、数据管理等功能。"
    }
  },

  common: {
    home: '首页',
    about: '关于我们',
    products: '产品中心',
    cases: '成功案例',
    news: '新闻资讯',
    contact: '联系我们',
    support: '服务支持',
    more: '了解更多',
    submit: '提交',
    cancel: '取消',
    learnMore: "了解更多->",
    language: '语言',
    slogan: '笃行致远'
  },
  nav: {
    about: '关于我们',
    productLibrary: '产品库',
    accessControl: '智能门禁',
    smartCabinet: '智能展柜 | 智能储物柜',
    softwarePlatform: '软件平台',
    accessControlPlatform: '智能门禁平台',
    displayPlatform: '智能展柜平台',
    afterSalesPlatform: '售后服务平台',
    services: '提供服务',
    accessControlSolution: '智能门禁解决方案',
    smartDisplaySolution: '智能展示柜解决方案',
    smartLockerSolution: '智能储物柜解决方案',
    glassDoorSolution: '玻璃门智能拉手锁',
    smartBuildingSolution: '智慧建筑解决方案'
  },
  home: {
    banner: {
      title: '上海杉脉科技发展有限公司',
      subtitle: '专注于提供优秀的用户界面体验',
      description: '上海杉脉电子科技发展有限公司（成立于2013年）专注于智能设备的设计、开发与生产，持有多项国内外专利及著作权。核心产品涵盖RFID智能管理系统及设备（珠宝店、校园、医院等场景应用）、智能门禁系统及设备（含智能展柜及储物柜），以及定制化开发服务。我司有安防系统和电子与智能化资质，可提供智能化系统集成、智慧楼宇、智慧园区等项目的解决方案设计及施工。',
      description_new: '专注于智能设备的设计、开发与生产'
    },
    about: {
      title: '关于我们',
      content: '上海杉脉科技发展有限公司是一家专注于技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广的公司。我们致力于为客户提供优质的软件开发、信息系统集成服务等解决方案。'
    },
    service: {
      title: '我们的服务',
      content: '我们提供全方位的技术服务，包括软件开发、信息系统集成、建筑智能化系统设计等。'
    },
    solutions: {
      title: '产品解决方案',
      learnMore: '了解详情',
      accessControl: {
        title: '智能门禁',
        content: 'SHM门禁管理系统涵盖独立式、云平台以及移动应用程序。我们的门禁产品在安全性、可管理性、灵活性等方面均表现出色，能为多数的使用场景提供安全保障并带来管理上的便利。'
      },
      smartDisplay: {
        title: '智能展示柜',
        content: 'SHM智能展示柜旨在构建更安全，更便捷、更智能的防护体系，助力高端零售业务数字化转型。针对传统机械柜锁束缚大、信息孤岛管理等问题，进一步规范业务流程、简化操作步骤、从而提升运营效率。助力门店智能化建设，赋能企业管理。'
      },
      smartLocker: {
        title: '智能储物柜',
        content: 'SHM智能储物系统，支持多种开启方式，能够快速实现物品的存取。它兼具高安全性与便捷性。能有效提升空间的利用率，方便管理员轻松调配。其灵活性出众，可设置临时或长期的使用权限，为企业和员工带来诸多便利。'
      },
      glassDoor: {
        title: '玻璃门拉手智能锁',
        content: '业内首创，独有设计；支持多种格式卡片、手机NFC开锁，支持无线联网、支持单机独立使用、免布线、拉手一体化安装；可满足多种场景使用。'
      },
      smartBuilding: {
        title: '智慧建筑\n智能照明',
        content: '对室内的灯光，空调，窗帘，投影，幕布，新风等设备采用场景一键切换;\n如投影模式:电动窗帘自动合上，灯光自投影至后,依次由暗至微亮，投影幕布自动下拉启动投影设备，更清晰的展示投影效果'
      },
      rfidTake: {
        title: 'RFID智能盘点',
        content: '采用 RFID 技术，搭配标签、读写器、天线等硬件及后台系统，可实现珠宝快速盘点、智能防丢失，提升门店管理效率与安全性，优化顾客体验。'
      }
    },
    businessCoverage: {
      title: '业务辐射',
      content: '杉脉科技拥有完善的产品研发，设计施工，销售及服务体系， 包括上海总部、国内其他多个办事处。持续为客户提供优质产品及服务'
    },
    markets: {
      banking: '银行金融',
      school: '学校',
      smartBuilding: '智能建筑',
      hospital: '医院',
      retail: '品牌零售',
      jewelry: '珠宝连锁'
    },
    nav: {
      home: '首页',
      qualification: '公司资质',
      products: '公司产品',
      aftersales: '售后服务',
      contact: '联系我们'
    }
  },
  about: {
    company: {
      title: '公司简介',
      content: '上海杉脉科技发展有限公司成立于上海，是一家专注于技术服务与开发的高新技术企业。'
    },
    vision: {
      title: '企业愿景',
      content: '成为行业领先的技术服务提供商，为客户创造更大的价值。'
    },
    mission: {
      title: '企业使命',
      content: '通过技术创新，提升客户体验，推动行业发展。'
    }
  },
  contact: {
    title: '联系我们',
    address: '地址',
    phone: '电话',
    email: '邮箱',
    message: '留言',
    name: '姓名',
    content: '内容',
    submit: '提交',
    banner: {
      title: '联系',
      description: '更多最新精彩资讯，感受企业魅力'
    },
    companyPhone: '公司电话',
    contactPerson: '联系人(李经理)',
    salesDirector: '联系人(崔经理)',
    companyEmail: '邮箱',
    headquarters: '公司总部地址：上海市杨浦区大连路588号宝地广场B座203室'
  },
  footer: {
    companyOverview: '企业概况',
    companyProducts: '公司产品',
    serviceSupport: '服务支持',
    contactUs: '联系我们',
    smartDisplay: '智能展柜',
    accessControl: '智能门禁',
    softwarePlatform: '软件平台',
    solutions: {
      accessControl: '智能门禁',
      smartDisplay: '智能展示柜',
      smartLocker: '智能储物柜',
      glassDoor: '玻璃门智能拉手锁',
      smartBuilding: '智慧建筑'
    },
    serviceHotline: '服务热线',
    serviceEmail: '邮箱',
    address: '地址：上海市杨浦区大连路588号宝地广场B座203室',
    copyright: 'Copyright © 上海杉脉科技发展有限公司',
    icp: '#网站备案号：沪ICP备19035700号#'
  },
  products: {
    specifications: '规格参数',
    productDetails: '产品详细参数',
    displayCase: {
      categories: {
        electronicLock: '电子锁',
        cardReader: '读卡器',
        controller: '控制器',
        powerSupply: '电源'
      },
      items: {
        miniatureElectronicLock: {
          name: '微型电子锁',
          description: '本产品为我司原创发明、设计生产，产品质量稳定可靠；符合公安消防要求；采用铸造工艺一次成型、耐磨损、耐腐蚀；机械结构和电子控制系统完美结合。'
        },
        smartEjectionLock: {
          name: '智能弹射锁',
          description: '产品质量稳定可靠；符合公安消防要求'
        },
        concealedMagneticLock: {
          name: '暗装磁力锁',
          description: '采用铝合金外壳，提升产品的质感，内置反向突破保护功能'
        },
        cylindricalCardReader: {
          name: '圆柱形读卡器(明装)',
          description: '圆柱形设计简约耐看，颜色可根据用户需求定制，内嵌红绿双色 LED 背光指示灯显示储物柜状态，背部螺纹卡口两种设计，方便安装【可以在金属表面开孔嵌入安装】'
        },
        implicitCardReader: {
          name: '读卡器(隐式安装)',
          description: '简洁的面板设计，智能芯片，室外防水设计。良好的抗金属干扰，可隐藏式安装'
        },
        allInOneCardReader: {
          name: '读卡器一体机',
          description: '将读卡器和控制器集成为一体，实现单机运行对单门的控制，小巧简约安装方便，支持嵌入式安装和表面安装，具备刷卡蜂鸣器和LED灯光反馈提示，最大支持1024个用户。'
        },
        singleDoorController: {
          name: '单门控制器',
          description: '标准维根读卡器接口，电锁接口，门磁接口支持关门延时时间设置'
        },
        threeDoorController: {
          name: '三门控制器',
          description: '标准维根读卡器接口，电锁接口，门磁接口支持关门延时时间设置'
        },
        sixDoorController: {
          name: '六门控制器',
          description: '标准维根读卡器接口，电锁接口，门磁接口支持关门延时时间设置'
        },
        tenDoorController: {
          name: '十门控制器',
          description: '10 路电锁，支持有电锁，无电锁，支持门磁输入2A@12V 电锁，动作时间 2 秒'
        },
        integratedPowerSupply: {
          name: '专用集成电源',
          description: '9 路 12V 专用集成电源，储物格以及桌面方便安装；前面板配置LED 电源指示灯；内置过 CQC 认证工业级模块电源，具有短路保护、过流保护，过载保护；'
        },
        switchingPowerSupply: {
          name: '开关电源',
          description: '设备机身由金属材质制作，电源底盖，采用铝合金材质，并有预留从底部安装以及正面安装的孔位，以便于不同场景进行安装固定；电源上盖外观采用六边形窝蜂孔贯穿盖体，便于设备的散热'
        }
      }
    },
    productParam: {
      products: {
        accessControlCardReader: {
          name: '门禁读卡器(刷卡/键盘/指纹)',
          features: [
            '支持 13.56MHz 高频',
            '支持配置卡更改读卡器参数',
            '支持单指纹、卡 + 指纹模式',
            '电容触摸式键盘',
            '支持电源反接保护',
            '防拆保护（光敏电阻）',
            '输入和输入信号防静电保护',
            '支持面板定制化设计'
          ]
        },
        accessControlCardReaderFingerprint: {
          name: '门禁读卡器(刷卡/指纹)',
          features: [
            '支持 13.56MHz 高频',
            '支持配置卡更改读卡器参数',
            '支持单指纹、卡 + 指纹模式',
            '支持电源反接保护',
            '防拆保护（光敏电阻）',
            '输入和输入信号防静电保护',
            '支持面板定制化设计'
          ]
        },
        accessControlCardReaderKeypad: {
          name: '门禁读卡器(刷卡/键盘)',
          features: [
            '支持 13.56MHz 高频',
            '支持配置卡更改读卡器参数',
            '电容触摸式键盘',
            '支持电源反接保护',
            '防拆保护（光敏电阻）',
            '输入和输入信号防静电保护',
            '支持面板定制化设计'
          ]
        },
        accessControlCardReaderSwipe: {
          name: '门禁读卡器(刷卡)',
          features: [
            '支持 13.56MHz 高频',
            '支持配置卡更改读卡器参数',
            '支持电源反接保护',
            '防拆保护（光敏电阻）',
            '输入和输入信号防静电保护',
            '支持面板定制化设计'
          ]
        },
        wirelessElectronicLock: {
          name: '无线电锁',
          features: [
            '智能，安全，创新和安装简单',
            '电子门锁无需布线，为您提供功能丰富的无布线网络化电子门锁解决方案',
            '可左右换向把手电子锁',
            '离合式电子锁，解锁之后把手可自由转动',
            '与欧标锁芯和瑞士标锁芯兼容',
            '任何类型的门都可进行简便的安装',
            '锁体和电子把手采用钢制结构',
            '可提供机械锁芯开孔，用于机械钥匙解锁或上锁 , 可通过审计追踪查询',
            '门锁始终可以从室内开启（选择相应的插芯锁体，只需压把手这一简单操作，即可实现紧急情况下逃生）'
          ]
        },
        pullLock: {
          name: '拉手锁',
          features: [
            '手机远程开锁',
            '独有安全网关，保障信息安全',
            '电源反接保护',
            '一体化设计，操作便捷',
            '支持NFC、刷卡模式',
            '防拆保护（光敏电阻）',
            '输入和输入信号防静电保护',
            '支持13.56MHz高频'
          ]
        },
        faceRecognitionMachine: {
          name: '人脸识别机',
          features: [
            '防窃取攻击',
            '活体检测',
            '支持传输机',
            '信息加密'
          ]
        },
        accessController: {
          name: '门禁控制器',
          features: [
            'RS485 和 Wiegand 双通讯接口可接入包括人脸识别、读卡器、指纹、人脸加卡片双重验证等读头',
            '通过 tcp/ip 有线网络连接到 S-MAX.A智能门禁管理平台进行管理。'
          ]
        },
        miniatureElectronicLock: {
          name: '微型电子锁',
          features: [
            '原创发明、设计生产，产品质量稳定可靠',
            '采用铸造工艺一次成型、耐磨损、耐腐蚀',
            '机械结构和电子控制系统完美结合',
            '全新的防撬功能设计',
            '锁体颜色可定制'
          ]
        },
        smartEjectionLock: {
          name: '智能弹射锁',
          features: [
            '通电弹开 / 断电手动关门上锁',
            '上锁闭合 / 开锁断开'
          ]
        },
        concealedMagneticLock: {
          name: '暗装磁力锁',
          features: [
            '铝合金外壳',
            '内置反向突破保护功能',
            '适用范围：抽屉、移门、柜门等'
          ]
        },
        cylindricalCardReader: {
          name: '圆柱形读卡器(明装)',
          features: [
            '支持 HID Prox 兼容卡，ISO14443A，ISO15693 等卡片技术（可选择不同的卡片技术）',
            '内嵌红绿双色 LED 背光指示灯显示储物柜状态',
            '背部螺纹卡口两种设计'
          ]
        },
        implicitCardReader: {
          name: '读卡器(隐式安装)',
          features: [
            '智能芯片',
            '室外防水设计',
            '良好的抗金属干扰',
            '可隐藏式安装'
          ]
        },
        allInOneCardReader: {
          name: '读卡器一体机',
          features: [
            '小巧简约',
            '嵌入式安装',
            '表面安装',
            '支持1024个用户'
          ]
        },
        tenDoorController: {
          name: '储物柜专用十门控制器',
          features: [
            '支持有电锁，无电锁',
            '支持门磁输入',
            '支持红色，绿色指示灯反馈'
          ]
        },
        singleDoorController: {
          name: '单门控制器',
          features: [
            '1 万持卡人，5 万 -10 万条离线事件',
            '支持关门延时时间设置',
            '表面安装',
            'TCP/IP 网络通信',
            '无线 WIFI 连接',
            '标准维根读卡器接口，电锁接口，门磁接口'
          ]
        },
        threeDoorController: {
          name: '三门控制器',
          features: [
            '1 万持卡人，5 万 -10 万条离线事件',
            '支持关门延时时间设置',
            '表面安装',
            'TCP/IP 网络通信',
            '无线 WIFI 连接',
            '标准维根读卡器接口，电锁接口，门磁接口'
          ]
        },
        sixDoorController: {
          name: '六门控制器',
          features: [
            '1 万持卡人，5 万 -10 万条离线事件',
            '支持关门延时时间设置',
            '表面安装',
            'TCP/IP 网络通信',
            '无线 WIFI 连接',
            '标准维根读卡器接口，电锁接口，门磁接口'
          ]
        },
        integratedPowerSupply: {
          name: '专用集成电源',
          features: [
            '储物格以及桌面方便安装',
            '前面板配置LED 电源指示灯',
            '内置过 CQC 认证工业级模块电源，具有短路保护、过流保护，过载保护',
            '输入带有短路保险管保护',
            '输出每路带独立指示灯，具有短路保护、过流保护，过载保护，每路接线端子可以插拔，便于安装和维护；',
            '标准维根读卡器接口，电锁接口，门磁接口',
            '具备可靠的防雷接地保护'
          ]
        },
        switchingPowerSupply: {
          name: '开关电源',
          features: [
            '设备机身由金属材质制作，电源底盖，采用铝合金材质',
            '电源上盖外观采用六边形窝蜂孔贯穿盖体，便于设备的散热',
            '预留从底部安装以及正面安装的孔位，以便于不同场景进行安装固定'
          ]
        },
        contactFreeSwitch: {
          name: '免接触开门按钮',
          features: [
            '非接触式',
            '采用非接触电容式感应技术'
          ]
        }
      },
      parameters: {
        deviceParams: '设备参数',
        usageParams: '使用参数',
        workingVoltage: '工作电压',
        cardFrequency: '读卡频率',
        readerConfig: '读卡器配置',
        standardOutput: '标准输出',
        readerOutputFormat: '读卡器输出格式',
        inputControl: '输入控制',
        wiegandWidth: '韦根宽度',
        keypadFormat: '键盘格式',
        readDistance: '读卡距离',
        waterproofLevel: '防水等级',
        productSize: '产品尺寸',
        shellMaterial: '外壳材质',
        productColor: '产品颜色',
        workingTemperature: '工作温度',
        workingHumidity: '工作湿度',
        doorThickness: '适用门厚度',
        size: '尺寸',
        handleRotationAngle: '把手转动角度',
        handleToCylinderDistance: '把手至锁芯的距离',
        operatingSystem: '操作系统',
        faceRecognition: '人脸识别',
        mainChipSpecs: '主要芯片规格',
        memory: '内存',
        wifiBluetoothModule: 'WiFi蓝牙模块',
        deviceSize: '设备尺寸(长宽高)',
        cameraModule: '摄像头模组(双目)',
        fillLight: '补光灯',
        display: '显示屏',
        screenRatio: '屏幕比例--分辨率',
        devicePower: '设备电源',
        deviceWattage: '设备功率',
        processor: '处理器',
        storageCapacity: '储存容量',
        workingCurrent: '工作电流',
        alarmOutput: '报警输出',
        lockRelay: '电锁继电器',
        bearableForce: '可承受里力',
        unlockMethod: '开锁方式',
        lockBodySize: '锁体尺寸',
        lockPlateSize: '锁扣板尺寸',
        electricalParams: '电气参数',
        workingMode: '工作方式',
        feedbackSignal: '反馈信号',
        doorOpeningForce: '开门弹力',
        suctionPlateSize: '吸板尺寸',
        tensileStrength: '承受拉力',
        installationMethod: '安装方式',
        maxOutputPower: '最大输出功率',
        outputVoltage: '输出电压',
        maxOutputCurrent: '最大输出电流',
        singleChannelOutputCurrent: '单路输出电流',
        inputVoltage: '输入电压',
        maxInputCurrent: '最大输入电流',
        standbyPowerConsumption: '待机功耗',
        outputProtection: '输出保护',
        totalOutputCurrent: '输出总电流',
        appearanceMaterial: '外观材质',
        alarmSound: '报警声音',
        communicationProtocol: '通讯协议',
        indicatorLight: '指示灯',
        structure: '结构',
        protectionLevel: '防护等级',
        readingDistance: '读取距离',
        cardReaderInterface: '读卡器接口',
        communicationInterface: '通讯接口',
        lockInterface: '电锁接口',
        values: {
          shaTouMenHouDu: '32mm 至 120mm',
          shaTouSuoXinDaoBaShou: '47mm 至 110mm',
          duKaQiPeiZhi: '重启后半小时内',
          weiGenShuChu: '韦根 (RS232 和 RS485 可选 )',
          duKaQiShuChuGeShi: '125KHz：HID 兼容卡格式、EM 26bits（默认）13.56MHz： UID 32bits, 34bits, 56bits ( 反向 /正向 ), 已编写的卡号',
          shuRuKongZhi: '三色 LED，蜂鸣器',
          weiGenKuanDu: '根据不同控制器的要求有不同的选择',
          waiKeCaiZhi: '铝',
          waiKeCaiZhiJinShu: '金属',
          chanPinYanSe: '银色、黑色',
          heiBai: '黑色、白色',
          tanHuiSe: '碳灰色',
          gongZuoShiDu: '10%~90%（非冷凝）',
          renLianShiBie: '最大 1 万人；1:1 模式、1:N 模式、混合模式',
          sheBeiChiCun: '78*141*60( 毫米 )/122"14.05*215 ( 毫米 )',
          sheXiangTouMoZu: '双目 200W，可见光 + 近红外',
          buGuangDeng: '白光 / 红外灯 850nm',
          gongZuoShiDuBuJingJieShuiDi: '0%-90%( 在不凝结水滴状态下 )',
          gongZuoDianYa12V: '自带机箱和供电电源（AC220 数日），工作电压 DC 12V，功耗≤ 4W（不带负载）',
          chuLiQi32: '32 位处理器',
          cunChuRongLiang: '5 万张卡和 10 万离线记录存储',
          baoJingShuChu: '干接点输出 ,30VDC 最大 2A',
          kaiSuoFangShi: '支持通电开锁 / 断电开锁',
          gongZuoFangShi: '通电弹开 / 断电手动关门上锁',
          fanKuiXinHao: '上锁闭合 / 开锁断开',
          waiKeCaiZhiABSandPc: 'ABS+PC 磨砂外壳',
          dingZhiYanSe: '可定制',
          biaoMianHuoQianRu: '表面安装、嵌入式安装',
          TCPTongXun: 'TCP 网络通讯',
          dianSuoJieKou: '10 路电锁，支持有电锁，无电锁，支持门磁输入2A@12V 电锁，动作时间 2 秒',
          duKaQiJieKou: '10 路读卡器，支持红色，绿色指示灯反馈5VDC 电源，韦根读卡器接口',
          danLuShuChu: '1~5 通道最大 5A 电流，6-9 通道最大 3A 电流；',
          chiCun1: '240mm*164mm*44mm（宽 * 深 * 高）',
          shuChuBaoHu: '输出短路、过流、过压、过温保护',
          shiDuWuLengJing: '20~90%RH，无冷疑',
          fengMingQi: '蜂鸣器',
          dianYuanZhiShiDeng: '电源指示灯和状态指示灯',
          suLiaoMianBan: '塑料面板',
          qianRuShi86DianHe: '适合埋入式86电器盒使用'
        }
      }
    }
  },
  entranceGuard: {
    bannerTitle: '智能门禁',
    bannerDescription: '智能门禁管理系统是基于公共智能管理平台搭建的门禁系统，系统通过公安三所检测，符合国家标准、符合上海公安技防标准。可有效管理门的开启与关闭，保证授权人员自由出入，限制未授权人员进入。',
    categoryName: {
      cardReader: '读卡器',
      wirelessLock: '无线电锁',
      faceRecognition: '人脸识别机',
      controller: '门禁控制器',
      openButton: '开门按钮'
    },
    cardReader: {
      cardKeypadFingerprint: '门禁读卡器(刷卡/键盘/指纹)',
      cardFingerprint: '门禁读卡器(刷卡/指纹)',
      cardKeypad: '门禁读卡器(刷卡/键盘)',
      cardOnly: '门禁读卡器(刷卡)',
      aluminumDescription: '采用铝合金外壳，提升产品的质感，增强读卡器抗干扰力，更适合现代建筑及工业建筑群',
      capacitiveDescription: '采用铝合金外壳，提升产品的质感，增强读卡器抗干扰力，更适合现代建筑及工业建筑群;采用电容式指纹模块，提升识别速度及准确率'
    },
    wirelessLock: {
      wirelessLock: '无线电锁',
      pullLock: '拉手锁',
      wirelessDescription: '智能，安全，创新和安装简单，电子门锁无需布线，为您提供功能丰富的无布线网络化电子门锁解决方案',
      pullLockDescription: '智能玻璃门拉手锁能够暗装于玻璃门把手内部，无需额外安装锁具。它拥有读卡、NFC等多种识别方式，通过蓝牙无线传输与私有安全网关相连'
    },
    faceRecognition: {
      faceRecognition: '人脸识别机',
      faceRecognitionDescription: '人脸识别系列智能终端，打造以安全为核心的软硬件一体化解决方案，人脸识别门禁产品分为 8 寸和 5.5寸两款，其中 5.5 寸产品可选配 IC 卡读卡器 • 适用门厚度：32mm 至 120mm。'
    },
    controller: {
      accessController: '门禁控制器',
      accessControllerDescription: '门禁控制器可同时对多个门锁进行控制开锁，拥有RS485 和 Wiegand 双通讯接口可接入包括人脸识别、读卡器、指纹、人脸加卡片双重验证等读头，通过 tcp/ip 有线网络连接到 S-MAX.A智能门禁管理平台进行管理。'
    },
    openButton: {
      contactFree: '免接触开门按钮',
      contactFreeDescription: 'SHM-RE0100 (Intelligence Request to Exit Button) 非接触式出门开关是一款非接触感应出门按钮 , 该出门按钮采用非接触电容式感应技术。'
    }
  },
  displayCase: {
    bannerTitle: '智能展柜 | 智能储物柜',
    bannerDescription: '智能展柜、智能储物柜是一种智能化的展示柜，通过数字技术结合定制化多媒体内容，智能展示柜管理平台实现了在云端对展示柜资产及状态的管理维护，通过智能控制器上报展示柜信息，可以在云端轻松查看门店展示柜的状态信息; 减少客户线下低效工作、降低设备遗失风险，提高展示柜管理效率。',
    categoryName: {
      electronicLock: '电子锁',
      cardReader: '读卡器',
      controller: '控制器',
      powerSupply: '电源'
    },
    electronicLock: {
      miniatureLock: '微型电子锁',
      smartEjectionLock: '智能弹射锁',
      concealedMagneticLock: '暗装磁力锁',
      miniatureLockDescription: '本产品为我司原创发明、设计生产，产品质量稳定可靠；符合公安消防要求；采用铸造工艺一次成型、耐磨损、耐腐蚀；机械结构和电子控制系统完美结合。',
      smartEjectionLockDescription: '产品质量稳定可靠；符合公安消防要求',
      concealedMagneticLockDescription: '采用铝合金外壳，提升产品的质感，内置反向突破保护功能'
    },
    cardReader: {
      cylindricalReader: '圆柱形读卡器(明装)',
      implicitReader: '读卡器(隐式安装)',
      allInOneReader: '读卡器一体机',
      cylindricalReaderDescription: '圆柱形设计简约耐看，颜色可根据用户需求定制，内嵌红绿双色 LED 背光指示灯显示储物柜状态，背部螺纹卡口两种设计，方便安装【可以在金属表面开孔嵌入安装】',
      implicitReaderDescription: '简洁的面板设计，智能芯片，室外防水设计。良好的抗金属干扰，可隐藏式安装',
      allInOneReaderDescription: '将读卡器和控制器集成为一体，实现单机运行对单门的控制，小巧简约安装方便，支持嵌入式安装和表面安装，具备刷卡蜂鸣器和LED灯光反馈提示，最大支持1024个用户。'
    },
    controller: {
      singleDoorController: '单门控制器',
      threeDoorController: '三门控制器',
      sixDoorController: '六门控制器',
      tenDoorController: '十门控制器',
      standardControllerDescription: '标准维根读卡器接口，电锁接口，门磁接口支持关门延时时间设置',
      tenDoorControllerDescription: '10 路电锁，支持有电锁，无电锁，支持门磁输入2A@12V 电锁，动作时间 2 秒'
    },
    powerSupply: {
      integratedPowerSupply: '专用集成电源',
      switchingPowerSupply: '开关电源',
      integratedPowerSupplyDescription: '9 路 12V 专用集成电源，储物格以及桌面方便安装；前面板配置LED 电源指示灯；内置过 CQC 认证工业级模块电源，具有短路保护、过流保护，过载保护；',
      switchingPowerSupplyDescription: '设备机身由金属材质制作，电源底盖，采用铝合金材质，并有预留从底部安装以及正面安装的孔位，以便于不同场景进行安装固定；电源上盖外观采用六边形窝蜂孔贯穿盖体，便于设备的散热'
    }
  },
  services: {
    accessControlSystem: {
      title: '智能管理',
      description: 'SHM门禁管理系统涵盖独立式、云平台以及移动应用程序。我们的门禁产品在安全性、可管理性、灵活性等方面均表现出色，能为多数的使用场景提供安全保障并带来管理上的便利。',
      productHardware: '产品硬件',
      productOverview: '产品介绍',
      productHardwareDesc: 'SHM 门禁产品包含智能人员识别类门禁、门禁控制器、发/读卡设备等等，具备更高效能、更高精度、更强安全性、更大便捷性等优势。',
      involvedProducts: '涉及产品',
      devices: {
        cardReader: {
          title: '门禁读卡器',
          description: 'SHM读卡器产品设计简约、扫描速度快、识别率高，包含卡片、指纹等多种类型。'
        },
        faceRecognition: {
          title: '人脸门禁一体机',
          description: 'SHM 人脸门禁一体机凭借深度学习算法，具备独立储存芯片，具备识别速度快、准确性高的特点。'
        },
        controller: {
          title: '门禁控制器',
          description: 'SHM多功能门禁控制器，采用RS485和Wiegand双通讯接口可接入包括多种读头，通过tcp/ip连接到S-MAX.A智能门禁管理平台，适用于各种复杂门禁管控场景。'
        },
        contactlessButton: {
          title: '免接触开关按钮',
          description: 'SHM-RE0100 (Intelligence Request to Exit Button) 非接触式出门开关是一款非接触感应出门按钮 , 该出门按钮采用非接触电容式感应技术。'
        }
      }
    },
    smartDisplayCase: {
      title: '运营数据可视化',
      description: 'SHM智能展示柜旨在构建更安全，更便捷、更智能的防护体系，助力高端零售业务数字化转型。针对传统机械柜锁束缚大、信息孤岛管理等问题，进一步规范业务流程、简化操作步骤、从而提升运营效率。助力门店智能化建设，赋能企业管理。',
      productHardware: '产品硬件',
      productHardwareDesc: 'SHM 展柜涵盖微型电锁、各类读卡器以及控制器等设备，具备联网版与单机版两种方案。在控制功能方面，提供了一拖一、一拖二、一拖三等多种选型，能够满足各类展柜的应用需求。',
      involvedProducts: '涉及产品',
      devices: {
        miniatureLock: {
          title: '微型电子锁(插销锁)',
          description: '自主研发设计生产，产品质量稳定可靠；采用全新的防撬功能设计；铸造工艺一次成型、耐磨损、耐腐蚀；机械结构和电子控制系统完美结合。'
        },
        cardReader: {
          title: '读卡器',
          description: '简洁的面板设计，智能芯片，室外防水设计。良好的抗金属干扰，可隐藏式安装'
        },
        cardReaderIntegrated: {
          title: '读卡器一体机',
          description: 'SHM多功能门禁控制器，采用RS485和Wiegand双通讯接口可接入包括多种读头，通过tcp/ip有连接到S-MAX.A智能门禁管理平台，适用于各种复杂门禁管控场景。'
        },
        controller: {
          title: '控制器',
          description: '1万持卡人，5万-10万条离线事件 / TCP/IP网络通信无线WIFI连接 / 标准维根读卡器接口，电锁接口，门磁接口,支持关门延时设置 / 表面安装结合。'
        }
      }
    },
    smartLockers: {
      title: '智能管理 | 安全稳定',
      description: 'SHM智能储物系统，支持多种开启方式，能够快速实现物品的存取。它兼具安全性与便捷性。能有效提升空间的利用率，方便管理员轻松调配。其灵活性出众，可设置临时或长期的使用权限，为企业和员工带来诸多便利。',
      productHardware: '产品硬件',
      productHardwareDesc: 'SHM 智能储物系列涵盖了诸如各类柜锁、储物柜专用多口控制器、读卡设备等相关设备，致力于为用户构建全方位、安全可靠的智能储物解决方案，具备更便捷、更灵活、更高效以及更安全等特性。',
      involvedProducts: '涉及产品',
      devices: {
        miniatureLock: {
          title: '微型电子锁(插销锁/弹力锁)',
          description: '自主研发设计生产，产品质量稳定可靠；采用全新的防撬功能设计；铸造工艺一次成型、耐磨损、耐腐蚀；机械结构和电子控制系统完美结合。'
        },
        cardReader: {
          title: '读卡器',
          description: '简洁的设计，智能芯片良好的抗金属干扰，'
        },
        specialController: {
          title: '储物柜专用控制器',
          description: '1万持卡人，5万-10万条离线事件 / TCP/IP网络通信无线WIFI连接 / 标准维根读卡器接口，电锁接口，门磁接口,支持关门延时时间设置 / 表面安装结合。'
        },
        integratedPowerSupply: {
          title: '专用集成电源(九口)',
          description: '内置通过 CQC 认证的工业级模块电源，具备短路保护、过流保护和过载保护功能；每路接线端子均可插拔，利于安装与维护。'
        }
      }
    },
    glassDoorHandleSmartLock: {
      title: '智能管理 | 安全稳定',
      description: '智能玻璃门拉手锁能够暗装于玻璃门把手内部，无需额外安装锁具。',
      productHardware: '产品硬件',
      productOverview: '产品介绍',
      productHardwareDesc: '智能玻璃门拉手锁能够暗装于玻璃门把手内部，无需额外安装锁具。它拥有读卡、NFC等多种识别方式，通过蓝牙无线传输与私有安全网关相连。',
      featureOverview: "功能介绍",
      featureOverviewDesc: "手机APP管理实时监控门锁的状态 \r\n" +
          "信息管理功能，管理员可编辑用户信息，方便管理成员、访客 \r\n" +
          "可实现总部对全国门店考勤数据的实时集中监控与管理 \r\n" +
          "多种开锁方式如NFC、刷卡、手机APP远程等 \r\n" +
          "支持电池电量监测功能",
      involvedProducts: '涉及产品',
      devices: {
        pullLock: {
          title: '拉手锁',
          description: '智能玻璃门拉手锁能够暗装于玻璃门把手内部，无需额外安装锁具。它拥有读卡、NFC等多种识别方式，通过蓝牙无线传输与私有安全网关相连。'
        }
      }
    },
    smartBuildings: {
      title: '智能管理 | 安全稳定',
      description: '让客户无论何时都可以感受到灯光带来的舒适、柔和、优雅的环境',
      architecture: {
        lobbyReception: {
          title: '大堂/接待区/吧台',
          description: '大堂是客人入住的必经之路，需要让顾客无论何时都可以感受到灯光带来的舒适、柔和、优雅的环境，通过智能调光细分为早/中/晚三种场景，将自然光和室内照明相互结合，更加富有层次感。'
        },
        banquetRestaurant: {
          title: '宴会厅/餐厅',
          description: '宴会大厅内需要应对各类场景需要，如准备模式，清洁模式，迎宾模式，晚餐模式，午餐模式，离场模式等等:对宴会厅内的筒灯，壁灯，灯带等进行智能调光控制，营造更好的灯光氛围'
        },
        conferenceRoom: {
          title: '会议室',
          description: '对会议室内的灯光，空调，窗帘，投影，幕布，新风等设备采用场景一键切换;如投影模式:电动窗帘自动合上，灯光自投影至后,依次由暗至微亮，投影幕布自动下拉启动投影设备，更清晰的展示投影效果，集聚与会者注意力。'
        }
      }
    },
    rfidTake: {
      title: 'RFID | 物品盘点',
      description: '通过部署RFID 标签、读写器、智能围栏、电子门禁等硬件设备与后台管理系统，实现快速盘点、实时监控、防盗报警、数据管理等功能，提升门店运营效率与安全性。',
      productHardware0: "智能展柜整体系统架构",
      productHardware: "货品防丢失",
      productHardwareDesc: "通过为每件珠宝配备唯一的 RFID 标签，并在关键位置设置 RFID 读写器，对标签信息进行实时监测，当珠宝离开预定区域或出现异常移动时触发警报，以此实现对珠宝的防丢失应用。",
      productHardware1: "门店智能管理",
      productHardwareDesc1: "利用 RFID 技术快速读取货品信息，实现快速智能盘点，从而节省人工成本，提高盘点效率，达到降本增效目的 ;\n " +
          "通过在珠宝门店的展柜安装电子门禁，可对珠宝货品进行有效管控，只有授权人员才能开启展柜，防止未经授权\n" +
          "的操作和取用，从而加强货品的安全系数。",
      architecture: {
        rfidRead: {
          title: '固定式RFID读写器',
          description: '固定式 RFID 读写器是部署于门店出入口、柜台等关键区域的设备，可实时读取标签信息，联动系统实现非法移动报警与数据管理。'
        },
        labelPrint: {
          title: '标签打印机',
          description: 'RFID 标签打印机可读写标签芯片数据并可视化打印，适配各种库存管理，助力身份识别与全流程追踪，提升管理效率。'
        },
        handheldTerminal: {
          title: '智能手持终端',
          description: '智能手持终端是珠宝门店高效管理工具，支持蓝牙连接，可实时读取 RFID 标签信息，便捷完成盘点、数据同步等操作，提升现场管理效率。'
        },
        rfidAntenna: {
          title: 'RFID天线',
          description: 'RFID 天线与读写器配合使用，通过发送射频信号并接收标签响应，实现标签信息的精准采集，为门店实时监控与数据管理提供基础支持。'
        }
      }
    }
  },
  entranceGuardSoftware: {
    bannerTitle: '智能门禁平台',
    title: '智能门禁平台',
    description: '杉脉门禁平台是一种集成了先进技术和人性化设计的门禁管理系统。',
    mainAdvantages: '主要优势',
    advantages: {
      accessControl: '对通道管理进出权限的管理',
      realTimeMonitoring: '实时监控功能',
      alarmFunction: '异常报警功能',
      networkMonitoring: '网络设置管理监控功能',
      areaRollCall: '区域点名功能',
      fireAlarm: '消防报警监控联动功能',
      logicalOpening: '逻辑开门功能',
      antiTailgating: '防尾随互锁功能',
      antiPassBack: '防返传功能'
    }
  },
  exhibitionSoftware: {
    bannerTitle: '智能展柜软件平台',
    title: '智能展柜软件平台',
    description: '杉脉柜展平台是一种集成了先进技术和人性化设计的柜展管理系统。',
    mainAdvantages: '主要优势',
    advantages: {
      realTimeManagement: '“实时” 综合管理',
      multiSystemSupport: '多种系统支持',
      communicationType: '伺服器与无线控制器通讯型式',
      windowsSupport: '软件支持视窗平台'
    }
  },
  aftTheSoftware: {
    bannerTitle: '售后运维服务平台',
    title: '售后运维服务平台',
    subtitle: '千锤百炼打造全程服务',
    serviceItems: {
      wechatRepair: '微信报修',
      mobileWorkOrder: '新版移动工单管理',
      wechatRepairDesc: '一键报修、智能派单、一键接单， 工程师位置定位。',
      customerManagement: '客户管理',
      voiceCall: '语音呼叫',
      customerManagementDesc: '客户级绑定，一键查询客户信息， 客户端一键呼叫工程师',
      engineerManagement: '工程师管理',
      areaRefinement: '区域细化',
      engineerManagementDesc: '工程师详细划分区域，分工明确， 更便于了解店铺详情',
      workOrderManagement: '工单管理',
      historyView: '历史工单查看',
      workOrderManagementDesc: '智能化管理工单，查询工单处理详情，处理结果一目了然',
      pcReport: 'PC端报表',
      pcReportDesc: 'PC端报表中心，一键导出，维修数据查看方便快捷'
    },
    processTitle: '售后平台流程',
    processSubtitle: '打造全程服务',
    processSteps: {
      submitWorkOrder: '提交工单',
      submitWorkOrderDesc: '多渠道、微信、电话等多种方式报修提交工单',
      acceptWorkOrder: '受理工单',
      acceptWorkOrderDesc: '客服微信、电话、后台等受理工单',
      assignWorkOrder: '指派工单',
      assignWorkOrderDesc: '一键指派工程师、派单提醒',
      acceptOrder: '接单',
      acceptOrderDesc: '工程师一键接单、手动指派工程师、接单提醒',
      returnOrder: '退单、二次派单等',
      returnOrderDesc: '突发情况、维修误报等',
      closeOrder: '结单',
      closeOrderDesc: '结单提交完单申请，发起满意度评价',
      satisfactionCall: '满意度回访',
      satisfactionCallDesc: '自动推送评价、系统默认评价等',
      finalizePayment: '办结工资',
      finalizePaymentDesc: '一键结单、维修内容汇报'
    }
  }
}
